import { Box, Typography } from '@mui/material';
import React, { FC } from 'react';
import { i18n } from '../../../../../../common/i18n/i18n';
import { ReactComponent as WebMentionsIcon } from '../../../../../../common/images/report-sidebar/web-mentions.svg';
import WebMentionRow from './components/WebMentionRow/WebMentionRow';
import _ from 'lodash';
import CustomList from '../../../../../../common/components/CustomList/CustomList';

interface WebMentionsProps {
    isPossibleMatches?: boolean;
    webMentions: any;
    findInput?: string;
    styles?: any;
}

const WebMentions: FC<WebMentionsProps> = ({ isPossibleMatches, webMentions, findInput, styles }) => {
    const defaultContainerStyles = {};
    const containerStyles = styles ? _.merge(defaultContainerStyles, styles) : defaultContainerStyles;
    return (
        <Box className="web-mentions" sx={containerStyles} data-testid="web-mentions">
            <Box sx={{ display: 'flex', alignItems: 'center', pt: 4 }}>
                <WebMentionsIcon className="fill-bd" style={{ width: '21px', height: '21px' }} />
                <Typography sx={{ ml: 1.6 }} variant="s28w700">
                    {i18n.translate('Web Mentions')}
                </Typography>
            </Box>
            <Typography variant="s16w400" className="color-md" sx={{ mt: 1, mb: 3 }}>
                {i18n.translate('WEB_MENTIONS_DESCRIPTION')}
            </Typography>
            <CustomList
                gap={{ width: 3, height: 3 }}
                list={webMentions.map((webMention, index) => (
                    <WebMentionRow
                        key={index}
                        isPossibleMatches={isPossibleMatches}
                        webMention={webMention}
                        findInput={findInput}
                    />
                ))}
            />
        </Box>
    );
};

export default WebMentions;
